import { Navigate, Outlet } from "react-router-dom";
import { UserManager } from "../../Utilities/UserManager";
import Routing from "./../../Routing/routing";

const AuthenticatedRedirectRoute = () => {
  return UserManager.get().isToken() ? <Navigate to={Routing.Main} /> : <Outlet />;
};

export default AuthenticatedRedirectRoute;
